const ItemTypes = {
  //enum-like list of dnd types, to be expanded if needed
  BOX: "box",
};

export default ItemTypes;
